'use client';

import { type HTMLAttributes } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';
import { useUpfrontShippingBannerVisibility } from './useUpfrontShippingBannerVisibility';

import { ON_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

type Props = HTMLAttributes<HTMLDivElement> & {
  ignoreExcludeList?: boolean;
};

export function UpfrontShippingBanner({
  className,
  ignoreExcludeList = false,
  ...rest
}: Props) {
  const t = useTranslations('common');

  const { web_upfront_shipping_banner } = useExperiments([
    'web_upfront_shipping_banner',
  ]);

  const { shouldHide } = useUpfrontShippingBannerVisibility();

  const isEnabled = web_upfront_shipping_banner === ON_IDENTIFIER;
  const effectiveShouldHide = ignoreExcludeList ? false : shouldHide;

  if (!isEnabled || effectiveShouldHide) {
    return null;
  }

  return (
    <div
      className={clsx(styles.container, className)}
      data-upfront-shipping-banner
      {...rest}
    >
      <div className={styles.imageContainer}>
        <img
          alt=""
          width="139"
          height="112"
          src={`${CLOUDFRONT_HOST}/web/assets/images/shipping/box-tee.png`}
        />
      </div>

      <Caption variant="sm-regular" colour="base">
        {t('UpfrontShipping.From')}
      </Caption>
    </div>
  );
}
